module.exports = __webpack_public_path__ + "static/media/a5.53ce032.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/penny/a5.mp3
// module id = pnA8
// module chunks = 0